import React from 'react';
import { InputRegNr as FInputElement } from '@folksam/ui-next/components';
import { useField } from 'react-final-form';
import { required, combineValidators, validRegNr } from '../../../services/validators.service';
import { useTranslation } from 'react-i18next';
import FormField from '../../FormField';

function Registration({ label, ...props }) {
    const { t } = useTranslation();

    // Define validators to match old angular validators, with matching error text from commondata translations
    const validators = combineValidators([
        required(t('empty_mandatory_error')),
        validRegNr(t('regnumber_validation_txt'))
    ]);

    // Setup the field in finalform
    const { input, meta } = useField(props.name, { validate: validators });

    return (
        <FormField
            label={label}
            meta={meta}
            id={props.fieldId}
            component={FInputElement}
            inputProps={{
                maxlength: '6',
                className: `sessioncamexclude`,
                ...props,
                id: props.fieldId,
                ...input
            }}
        />
    );
}
export default Registration;
